import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export interface FeaturesMegaMenuGetStartedWrapperProps {
  noBackground?: boolean;
}

export const FeaturesMegaMenuGetStartedWrapper = styled.div<FeaturesMegaMenuGetStartedWrapperProps>`
  margin: 0 auto;
  box-sizing: border-box;
  padding: 3.5rem 1rem;
  background: ${({ noBackground }) => (noBackground ? 'none' : palette.lightWheat)};
  border-left: ${({ noBackground }) => (noBackground ? 'none' : `solid 1px ${palette.wheat}`)};
  width: 100%;

  @media all and (max-width: ${layout.lg}) {
    padding: 1rem;
  }

  @media all and (max-width: ${layout.xs}) {
    padding: 1rem 0;
  }
`;

export interface FeaturesMegaMenuGetStartedContainerProps {
  isFullWidth?: boolean;
}

export const FeaturesMegaMenuGetStartedContainer = styled.div<FeaturesMegaMenuGetStartedContainerProps>`
  display: grid;
  width: 100%;
  row-gap: 1.5rem;
  max-width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '436px')};
  margin: 0 auto;
`;

export const FeaturesMegaMenuGetStartedImages = styled.div`
  display: grid;
  row-gap: 1.5rem;
  grid-template-columns: 1fr;

  @media all and (max-width: ${layout.lg}) {
    column-gap: 1rem;
    grid-template-columns: 1fr 1fr;
  }

  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 1fr;
  }
`;

export const FeaturesMegaMenuGetStartedImage = styled.div`
  display: grid;
  border-radius: 16px;
  overflow: hidden;
  grid-template-columns: 240px 1fr;

  .image-text {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    position: relative;
    z-index: 2;
  }
  .gatsby-image-wrapper {
    grid-row: 1 / 2;
    grid-column: 1 / 3;
  }

  @media all and (max-width: ${layout.lg}) {
    grid-template-columns: 55% auto;
  }

  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 45% auto;
  }

  @media all and (max-width: ${layout.xs}) {
    grid-template-columns: 50% auto;
  }
`;

export const FeaturesMegaMenuGetStartedImageText = styled.div`
  display: flex;
  flex-flow: column wrap;
  padding: 1.5rem 0 1.125rem 1.5rem;

  .image-title {
    flex: 1 1 auto;
  }

  .image-link {
    align-self: flex-start;
    border-radius: 0;
    padding-bottom: 0;

    .link-branded-text {
      border-bottom: solid 1px ${palette.white};
    }
  }

  @media all and (max-width: ${layout.xxs}) {
    .image-title {
      font-size: 0.875rem;
    }
  }

  @media all and (max-width: 375px) {
    padding: 1rem 0 1rem 1rem;
  }
`;

export const FeaturesMegaMenuGetStartedLinks = styled.div`
  display: grid;
  padding-top: 0.5rem;
`;

export const FeaturesMegaMenuGetStartedLink = styled(LinkBranded)`
  width: fit-content;
  justify-self: start;
  padding-left: 0;
  font-weight: 700;
`;

export const FeaturesMegaMenuGetStartedLinkDivider = styled.div`
  display: none;

  @media all and (max-width: ${layout.lg}) {
    display: block;
    width: 100%;
    border-top: solid 1px ${palette.greyText};
    margin: 0.75rem 0;
    opacity: 0.25;
  }
`;
